<div class="container-fluid ps-md-0">
  <div class="row g-0 vh-100">
    <div
      *ngIf="personType == 'pf'"
      class="d-none d-md-flex col-md-4 col-lg-6 bg-image"
      [ngStyle]="{
        'background-image':
          'url(../../../../assets/image/merchants/' +
          tenant +
          '/bg-login-pf.svg)'
      }"
    >
      <div class="text mt-5">
        <span [innerHTML]="getWelcomeText()"></span>
      </div>
      <div class="logo">
        <div class="text-white" *ngIf="tenant !== tenantService.XP_NAME">
          <span>Fornecido por: </span>
        </div>
        <br />
        <img src="../../../../assets/image/oz-white-logo.svg" alt="logo" />
      </div>
    </div>

    <div
      *ngIf="personType == 'pj'"
      class="d-none d-md-flex col-md-4 col-lg-6 bg-image"
      [ngStyle]="{
        'background-image':
          'url(../../../../assets/image/merchants/' + tenant + '/bg-login.svg)'
      }"
    >
      <div class="text mt-5">
        <span [innerHTML]="getWelcomeText()"></span>
      </div>
      <div class="logo">
        <div class="text-white" *ngIf="tenant !== tenantService.XP_NAME">
          <span>Fornecido por: </span>
        </div>
        <br />
        <img src="../../../../assets/image/oz-white-logo.svg" alt="logo" />
      </div>
    </div>

    <div class="col-md-8 col-lg-6 content-center">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
